<template>
  <div class="navigation">
    <nav class="navbar--top">

      <div class="item inline">
        <a href="https://www.instagram.com/tracksystems/" title="Instagram" rel="nofollow" class="none">
          <font-awesome-icon :icon="['fab', 'instagram']"/> <span class="xs-hide"> Instagram</span>
        </a>
      </div>

      <div class="item inline">
        <a href="https://www.facebook.com/Raupenlaufwerk/" title="Facebook" rel="nofollow" class="none">
          <font-awesome-icon :icon="['fab', 'facebook']"/> <span class="xs-hide"> Facebook</span>
        </a>
      </div>
      <div class="item inline">
        <a href="tel:+43 (0) 660 828 2238" title="Tel.: 43 (0) 660 828 2238" rel="nofollow" class="none">
          <font-awesome-icon icon="phone" /> <span class="xs-hide"> +43 (0) 660 828 2238</span>
        </a>
      </div>
      <div class="item inline">
        <a href="mailto:pt@tracksystems.eu" title="E-Mail: pt@tracksystems.eu" rel="nofollow" class="none">
          <font-awesome-icon icon="envelope" /> <span class="xs-hide"> pt@tracksystems.eu</span>
        </a>
      </div>
    </nav>

    <nav class="navbar--dark">
      <div class="navbar--brand">
        <div class="navbar-item">
          <router-link class="navbar-item none" title="Tracksystems" :to="{ name: 'Home'}">
            <img src="../assets/tracksystems.svg" alt="Tracksystems">
          </router-link>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

  export default {
    name: 'app-headers'
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue